module.exports = __webpack_public_path__ + "dlssrvtline2/img/th-slider-1.jpg?954a1341";